module.exports = __webpack_public_path__ + "img/upload.e015184e.svg";